import React, { ReactNode } from "react";
import classNames from "classnames";
import { Link } from "react-router-dom";

interface ButtonProps {
  children: ReactNode;
  variant: "primary" | "secondary";
  size: "sm" | "md" | "lg" | "full-half";
  type?: "button" | "submit" | "reset";
  href?: string;
  className?: string;
  onClick?: (e?: any) => void;
  disabled?: boolean;
}

const Button = ({
  size = "lg",
  variant,
  children,
  type,
  href,
  onClick,
  className,
  disabled = false,
}: ButtonProps) => {
  const buttonClassNames = classNames(
    "inline-flex items-center justify-center text-center px-5 py-2 gap-2 border-2 border-[#0979A1] rounded-lg font-bold text-sm md:text-sm",
    {
      "w-full": size === "lg",
      "w-[75%]": size === "md",
      "w-[50%]": size === "sm",
      "w-full md:w-[50%]": size === "full-half",
      "text-[#fff] bg-[#0979A1] hover:opacity-75": variant === "primary" && !disabled,
      "text-[#0979A1]": variant === "secondary" && !disabled,
      "opacity-50 cursor-not-allowed": disabled,
    },
    className
  );

  return href ? (
    <Link to={href} className={buttonClassNames}>
      {children}
    </Link>
  ) : (
    <button
      className={buttonClassNames}
      type={type}
      onClick={disabled ? undefined : onClick} 
      disabled={disabled} 
    >
      {children}
    </button>
  );
};

export default Button;
